export default __webpack_public_path__ + "static/media/Figtree-Bold.5c783233.ttf";